// extracted by mini-css-extract-plugin
module.exports = {"row":"VehicleReportAvailability_row_DKTyj"};